import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { useWindowSize } from '../../../hooks/windowSize';

interface INoDataMessage {
  title: string;
  message?: string;
}

const NoDataMessage: React.FC<INoDataMessage> = ({ title, message }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const size = useWindowSize();

  return (
    <div
      className={classes.container}
      style={{ height: size.height ? size.height * 0.25 : '100%' }}
    >
      <Typography variant="h3" className={classes.title}>
        {title}
      </Typography>
      <div className={classes.messageContainer}>
        <Typography variant="h3">
          {message || t('components:charts.noData')}
        </Typography>
      </div>
    </div>
  );
};

export default NoDataMessage;
